export default __webpack_public_path__ + "static/media/card3.c0ecfe15.svg";